import { useState, useEffect } from "react";
/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/core";
import { mq } from "../responsive";

const Option = ({ onClick, checked, children }) => {
  return (
    <span
      onClick={onClick}
      css={{
        borderRadius: "2rem",
        padding: "1rem 4rem",
        border: "2px solid #DEF4E5",
        backgroundColor: checked ? "#DEF4E5" : "transparent",
        cursor: "pointer",
        userSelect: "none",
        display: "inline-block",
        color: "#50976A",
        fontSize: "2rem",
        margin: "1rem 2rem 1rem 0",
        whiteSpace: "nowrap",
        transition: "all 0.2s ease-in-out",
      }}
    >
      {children}
    </span>
  );
};

const CheckBox = ({ options, onChange, styles, single, ...props }) => {
  const [data, setData] = useState(options);

  useEffect(() => {
    onChange && onChange(data.filter((ele) => ele.selected));
  }, [data]);

  const handleOptionClick = (value) => {
    setData((data) => {
      const newData = data.map((e) => {
        let selected = e.selected;
        if (single && e.value !== value) selected = false;
        if (e.value === value) selected = !selected;
        return { ...e, selected };
      });

      return newData;
    });
  };

  return (
    <div
      css={{
        "&::-webkit-scrollbar": {
          display: "none",
        },

        [mq.md]: {
          flexWrap: "wrap",
        },

        ...styles,
        ...props,
      }}
    >
      {data.map((option, i) => (
        <Option
          key={i}
          checked={option.selected}
          onClick={() => handleOptionClick(option.value)}
        >
          {option.label}
        </Option>
      ))}
    </div>
  );
};

export default CheckBox;
